import "./RoboticsCourseHp5.module.css";
import Header from "@/reusable_sections/Header";
import CourseDetail from "./sections/CourseDetail";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseHp5Page() {
  return <div>
      <Header />
      <CourseDetail />
      <Footer />
    </div>;
}